// Enforces min percentage so tiny values are large enough to interact with
export function minPercentage(val: number, total: number, min: number) {
  return percentage(val, total) < min ? total * (min / 100) : val;
}

export function percentage(val: number, total: number) {
  return (val / total) * 100;
}
